import apiClient from './client';

// ===== Team/League Mappings API =====

export interface TeamMapping {
  team_id: number;
  sport_name: string;
  sport_name_kr?: string;
  league_code: string | null;
  team_name: string;
  spojoy_name: string | null;
  psynet_name: string | null;
}

export interface LeagueMapping {
  league_id: number;
  sport_id: number;
  sport_name?: string;
  sport_name_kr?: string;
  league_code: string;
  league_name: string;
  psynet_league_id: string | null;
}

// 팀 매핑 목록 조회
export const getTeamMappings = async (
  sport?: string,
  league?: string
): Promise<{
  status: string;
  count: number;
  data: TeamMapping[];
}> => {
  const params = new URLSearchParams();
  if (sport) params.append('sport', sport);
  if (league) params.append('league', league);

  const response = await apiClient.get(`/api/mappings/teams?${params.toString()}`);
  return response.data;
};

// 팀 매핑 생성
export const createTeamMapping = async (data: {
  sport_name: string;
  team_name: string;
  spojoy_name?: string;
  psynet_name?: string;
  league_code?: string;
}): Promise<{
  status: string;
  message: string;
  team_id: number;
}> => {
  const response = await apiClient.post('/api/mappings/teams', data);
  return response.data;
};

// 팀 매핑 수정
export const updateTeamMapping = async (
  teamId: number,
  data: { spojoy_name?: string; psynet_name?: string }
): Promise<{
  status: string;
  message: string;
  team_id: number;
}> => {
  const response = await apiClient.put(`/api/mappings/teams/${teamId}`, data);
  return response.data;
};

// 팀 매핑 삭제
export const deleteTeamMapping = async (teamId: number): Promise<{
  status: string;
  message: string;
  team_id: number;
}> => {
  const response = await apiClient.delete(`/api/mappings/teams/${teamId}`);
  return response.data;
};

// matches에서 팀 동기화
export const syncTeamsFromMatches = async (): Promise<{
  status: string;
  message: string;
  created: number;
  skipped: number;
  total: number;
}> => {
  const response = await apiClient.post('/api/mappings/teams/sync');
  return response.data;
};

// 리그 매핑 목록 조회
export const getLeagueMappings = async (
  sport?: string
): Promise<{
  status: string;
  count: number;
  data: LeagueMapping[];
}> => {
  const params = new URLSearchParams();
  if (sport) params.append('sport', sport);

  const response = await apiClient.get(`/api/mappings/leagues?${params.toString()}`);
  return response.data;
};

// 리그 Psynet 매핑 업데이트
export const updateLeaguePsynetMapping = async (
  leagueCode: string,
  psynetLeagueId: string
): Promise<{
  status: string;
  message: string;
  league_code: string;
  psynet_league_id: string;
}> => {
  const response = await apiClient.put(`/api/mappings/leagues/${leagueCode}/psynet`, {
    psynet_league_id: psynetLeagueId
  });
  return response.data;
};

// 종목 목록 조회
export const getSports = async (): Promise<{
  status: string;
  count: number;
  data: Array<{ sport_id: number; sport_name: string; sport_name_kr: string }>;
}> => {
  const response = await apiClient.get('/api/mappings/sports');
  return response.data;
};
